// API client for the Promotional Calendar & Planner.
//
// Nothing here submits, creates or edits anything on Amazon.
const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';
const BASE = `${API_URL}/seller-intelligence/promo-calendar`;

const authHeaders = (token) => ({
  Authorization: `Bearer ${token}`,
  'Content-Type': 'application/json',
});

export class ReportUnavailableError extends Error {
  constructor(message) { super(message); this.reportUnavailable = true; }
}

export class NotConnectedError extends Error {
  constructor(message) { super(message); this.notConnected = true; }
}

const call = async (url, options = {}) => {
  const res = await fetch(url, options);
  const data = await res.json().catch(() => ({}));
  if (res.status === 409 && data.error === 'report_unavailable') {
    throw new ReportUnavailableError(data.message);
  }
  if (res.status === 400 && data.error === 'amazon_not_connected') {
    throw new NotConnectedError(data.message);
  }
  if (!res.ok) throw new Error(data.message || `Request failed (${res.status})`);
  return data;
};

// SF1 — past promotions on a time axis, coloured by net.
export const getHistory = (token) =>
  call(`${BASE}/history`, { headers: authHeaders(token) });

// SF4 — allocate a budget by return per rupee.
export const getBudget = (token, { budget } = {}) =>
  call(`${BASE}/budget${budget ? `?budget=${budget}` : ''}`,
    { headers: authHeaders(token) });

// SF3 — festival suggestions; states its dependency rather than guessing.
export const getFestivals = (token) =>
  call(`${BASE}/festivals`, { headers: authHeaders(token) });

// SF5 — what will go wrong with what is scheduled.
export const postConflicts = (token, payload) =>
  call(`${BASE}/conflicts`, {
    method: 'POST', headers: authHeaders(token), body: JSON.stringify(payload),
  });
